import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Lista de ícones coloridos disponíveis (você pode adicionar mais)
const colorIcons = [
  "red", "green", "orange", "blue", "gold", "violet", "grey", "black",
];

const iconUrlBase = "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/";

// Cria ícones por cor
const iconsByColor = colorIcons.reduce((acc, color) => {
  acc[color] = new L.Icon({
    iconUrl: `${iconUrlBase}marker-icon-2x-${color}.png`,
    shadowUrl: `${iconUrlBase}marker-shadow.png`,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  });
  return acc;
}, {});

const MapView = ({ markersData }) => {
  // Centraliza o mapa no primeiro marcador
  const center = markersData.length
    ? markersData[0].htv_internalvalue.split(",").map(Number)
    : [-8.09, -34.94];

  // Mapeia cada tsk_alternativeidentifier para uma cor fixa
  const identifierToColor = {};
  let colorIndex = 0;

  markersData.forEach((item) => {
    const id = item.tsk_alternativeidentifier;
    if (!identifierToColor[id]) {
      const color = colorIcons[colorIndex % colorIcons.length];
      identifierToColor[id] = color;
      colorIndex++;
    }
  });

  return (
    <MapContainer center={center} zoom={15} style={{ height: "700px", width: "100%" }}>
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

      {markersData.map((item, index) => {
        const [lat, lng] = item.htv_internalvalue.split(",").map(Number);
        const color = identifierToColor[item.tsk_alternativeidentifier];
        const icon = iconsByColor[color];

        return (
          <Marker position={[lat, lng]} icon={icon} key={index}>
            <Popup>
              ID: {item.tsk_id}
              <br />
              Nome: {item.age_name}
              <br />
                Local: {item.ativo}
              <br />
              Atividade: {item.act_description}
            </Popup>
          </Marker>
        );
      })}
    </MapContainer>
  );
};

export default MapView;
